import { render, staticRenderFns } from "./GenoExperimentalInvoicePage.vue?vue&type=template&id=15e8cea0&scoped=true&"
import script from "./GenoExperimentalInvoicePage.vue?vue&type=script&lang=ts&"
export * from "./GenoExperimentalInvoicePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8cea0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
